import React from "react";
import "./App.scss";
import MileagePlanData from "./services/MPDataService";
import UserAccountContext from "./context/UserAccountContext";
import { reactPlugin } from "./services/AppInsights";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";

import OptimizelyContextProvider from "./context/OptimizelyContextProvider";
import ContentContext from "./context/ContentContext";
import ContentService from "./services/content-service";

const AppContainer = React.lazy(() => import("./components/AppContainer/AppContainer"));

const App = () => {

  let mileagePlanData = MileagePlanData();
  const content = ContentService();
  
  return (
      <ContentContext.Provider value={content}>
          <UserAccountContext.Provider value={mileagePlanData}>
              <AppInsightsContext.Provider value={reactPlugin}>
                  <OptimizelyContextProvider
                      userId={mileagePlanData.accountState.Token.Guid}
                      mileagePlanNumber={mileagePlanData.accountState.Token.AlaskaLoyaltyNumber}>
                        <AppContainer />
                  </OptimizelyContextProvider>
              </AppInsightsContext.Provider>
          </UserAccountContext.Provider>
      </ContentContext.Provider>
  );
};

export default App;
